function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FBFBFB",
  clipPath: "url(#money-circle_svg__clip0_242_46739)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.364 5.095c-3.182 0-5.771 2.649-5.771 5.905 0 3.256 2.589 5.905 5.77 5.905 3.183 0 5.771-2.65 5.771-5.905 0-3.256-2.588-5.905-5.77-5.905zm.441 7.895v.608h-.755v-.58c-.535-.033-1.054-.18-1.375-.384l.407-.941c.353.213.824.35 1.236.35.359 0 .487-.077.487-.208 0-.482-2.071-.093-2.071-1.523 0-.618.439-1.139 1.316-1.264V8.45h.755v.586c.396.038.781.142 1.087.317l-.38.937c-.37-.192-.718-.285-1.044-.285-.37 0-.487.11-.487.24 0 .46 2.071.077 2.071 1.49 0 .592-.417 1.106-1.247 1.254z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.123 9.908l-1.144.13a9.062 9.062 0 01-1.29 5.702 8.716 8.716 0 01-4.573 3.67 8.475 8.475 0 01-2.752.458 8.734 8.734 0 01-6.897-3.4h1.14v-1.179H1.53v3.296H2.68v-1.241a9.945 9.945 0 004.205 3.064 9.75 9.75 0 003.47.638 9.645 9.645 0 003.126-.519 9.875 9.875 0 005.181-4.158 10.266 10.266 0 001.461-6.461zM2.998 6.334a8.713 8.713 0 014.614-3.737 8.392 8.392 0 015.671.059 8.735 8.735 0 013.708 2.634h-1.098v1.178l3.113.001V3.321h-1.152v1.19a9.893 9.893 0 00-4.182-2.964 9.508 9.508 0 00-6.426-.067 9.871 9.871 0 00-5.227 4.234 10.259 10.259 0 00-1.394 6.568l1.142-.151a9.055 9.055 0 011.231-5.797z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "money-circle_svg__clip0_242_46739"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.545 .953)",
  d: "M0 0h19.636v20.093H0z"
})));

function SvgMoneyCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMoneyCircle;